import { render, staticRenderFns } from "./CollectionSliderWrapper.vue?vue&type=template&id=53bf1ba8&scoped=true&"
import script from "./CollectionSliderWrapper.vue?vue&type=script&lang=js&"
export * from "./CollectionSliderWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CollectionSliderWrapper.vue?vue&type=style&index=0&id=53bf1ba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bf1ba8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53bf1ba8')) {
      api.createRecord('53bf1ba8', component.options)
    } else {
      api.reload('53bf1ba8', component.options)
    }
    module.hot.accept("./CollectionSliderWrapper.vue?vue&type=template&id=53bf1ba8&scoped=true&", function () {
      api.rerender('53bf1ba8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionSliderWrapper.vue"
export default component.exports